<script>
import Multiselect from 'vue-multiselect'
import UploadFile from '@components/upload-file'

export default {

    components: { Multiselect, UploadFile },

    props: {

    },

    data() {
        return {
            trackBy: 'operator_uuid',
            provider: null,
            initProvider: [],
            providers_option: []
        }
    },

    watch: {
        initProvider: {
            immediate: true,
            handler(values) {
                this.provider = this.providers_option.filter(x => values.includes(x[this.trackBy]));
                this.provider = this.provider[0];
            }
        },
        provider: {
            immediate: true,
            handler(values) {
                if(this.provider){
                    this.$parent.sms_send.provider = this.provider.operator_code ? this.provider.operator_code : null;
                    this.$parent.sms_send.provider_uuid = this.provider.operator_uuid ? this.provider.operator_uuid : null
                } else {
                    this.$parent.sms_send.provider = null;
                    this.$parent.sms_send.provider_uuid = null
                }
            }
        }
    },

    computed: {
        operators_tariffs_list_data(){
            return this.$store.getters['operatorsTariffs/GET_OPERATORS_TARIFFS_LIST_DATA'];
        },
    },

    async mounted() {

        let data_send = {
            'filter'     : this.$parent.params.sms_send.product_code ? this.$parent.params.sms_send.product_code : this.$parent.sms_send.product_code,
            'filterOn'   : JSON.stringify(['product_code']),
            'get_fields' : JSON.stringify(['operator_code', 'operator_name', 'operator_uuid', 'product_code']),
            'groupBy'    : JSON.stringify(['operators.code', 'operators.name', 'operators.uuid', 'products.code']),
        }

        await this.$store.dispatch('operatorsTariffs/FETCH_OPERATORS_TARIFFS_LIST', data_send);

        this.providers_option = this.operators_tariffs_list_data;
        
        if(this.$parent.params.sms_send && this.$parent.params.sms_send.provider_uuid) {
            this.initProvider = [this.$parent.params.sms_send.provider_uuid];
        }
    },

    methods: {

    }
}
</script>

<template>
    <div>
        <b-form-group
            label="Провайдер"
            label-for="provider"
        >
            <multiselect
                id="provider"
                v-model="provider"
                :options="providers_option"
                placeholder="Выберите из списка"
                selectLabel="Нажмите, чтобы выбрать"
                deselectLabel="Нажмите, снять выделение"
                label="operator_name"
                :track-by="trackBy"
            ></multiselect>
        </b-form-group>

        <b-form-group
            label="Номер телефона"
            label-for="sms_send_phone"
        >
            <b-form-input
                id="sms_send_phone"
                v-model="$parent.sms_send.phone"
            ></b-form-input>
        </b-form-group>



    </div>
</template>
